export const setCreditCardData = (payload) => ({
  type: 'CREDIT_CARD_DATA',
  payload,
});
